// frontend/src/services/auth.js
import { apiService } from './api';

export const authAPI = {
  async login(email, password) {
    return apiService.post('/auth/login', { email, password }, { skipAuth: true });
  },

  async register(userData) {
    return apiService.post('/auth/register', userData, { skipAuth: true });
  },

  async getProfile() {
    return apiService.get('/users/profile');
  },

  async updateProfile(userData) {
    return apiService.put('/users/profile', userData);
  },

  async deleteAccount() {
    return apiService.delete('/users/profile');
  }
};
